export const SET_USER = 'SET_USER'
